import {
  Profile,
  ApiClientError,
  UnauthorizedError,
} from '@raydiant/api-client-js';
import raydiant from '../clients/raydiant';
import useProtectedQuery from './useProtectedQuery';
import { keys } from '../queryClient';

export default function useCurrentUser() {
  const query = useProtectedQuery<Profile, ApiClientError>(
    keys.profile(),
    () => raydiant.getProfile(),
    {
      // Cache the current user profile for the lifetime of the page.
      staleTime: Infinity,
      // Retrying a 401 only delays the login redirect.
      retry: (failureCount, error) =>
        !(error instanceof UnauthorizedError) && failureCount < 3,
    },
  );

  return query;
}
